// extracted by mini-css-extract-plugin
export default {"container":"header_container__k7-4f","name":"header_name__FwwHt","total":"header_total__j1WHh","products":"header_products__Hl-0b"};